import React from "react";
import {
  Wrench,
  Bot,
  Boxes,
  Cpu,
  Settings,
  Monitor,
  MoreHorizontal,
  ArrowRight,
  Info,
} from "lucide-react";
import "./Programoffer.css";

// Import images
import charmimarImage from "../img/aaaservices/minar.jpg";
import hawaMahalImage from "../img/aaaservices/jaipur.webp";
import jaipurImage1 from "../img/aaaservices/VR.webp";
import jaipurImage2 from "../img/aaaservices/design.avif";

/**
 * ProgramsSection
 * A responsive "Programs We Offer" showcase with two center highlights
 * (an established center + a launching-soon center) framed by two
 * side hero images. Mobile-first: side images collapse away on
 * small screens, cards stack, and the grid re-flows from 4 -> 2 -> 1
 * columns as the viewport narrows.
 */

const hyderabadPrograms = [
  { icon: Wrench, label: "Tool Design & Manufacturing" },
  { icon: Bot, label: "Robotics & Automation" },
  { icon: Boxes, label: "Digital Manufacturing" },
  { icon: Cpu, label: "Industrial Automation" },
  { icon: Settings, label: "Mechanical Design & CAD" },
  { icon: Monitor, label: "IT & Emerging Technologies" },
];

const jaipurPrograms = [
  {
    icon: Wrench,
    label: "Tool Design & Manufacturing",
    image: jaipurImage1,
  },
  {
    icon: Bot,
    label: "Robotic Simulation & Programming",
    image: jaipurImage2,
  },
];

function ProgramCard({ icon: Icon, label }) {
  return (
    <div className="ps-program-card">
      <Icon className="ps-program-icon" strokeWidth={1.75} />
      <span className="ps-program-label">{label}</span>
    </div>
  );
}

function JaipurCard({ icon: Icon, label, image }) {
  return (
    <div className="ps-jaipur-card">
      <div className="ps-jaipur-image-wrap">
        <img src={image} alt={label} className="ps-jaipur-image" loading="lazy" />
        <div className="ps-jaipur-overlay" />
        <Icon className="ps-jaipur-icon" strokeWidth={1.75} />
      </div>
      <div className="ps-jaipur-label-wrap">
        <span className="ps-program-label">{label}</span>
      </div>
    </div>
  );
}

function SideImage({ src, alt, side }) {
  return (
    <div className={`ps-side-image ps-side-image--${side}`}>
      <img src={src} alt={alt} loading="lazy" />
      <div className="ps-side-image-overlay" />
    </div>
  );
}

export default function ProgramsSection() {
  return (
    <section className="ps-section" aria-labelledby="programs-title">
      {/* Header */}
      <div className="ps-header">
        {/* <p className="ps-eyebrow">Programs We Offer</p> */}
        <h2 id="programs-title" className="ps-title">
          Industry-Focused Programs for In-Demand Careers
        </h2>
      </div>

      {/* Main grid: side image | Hyderabad card | Jaipur card | side image */}
      <div className="ps-grid">
        <SideImage
          side="left"
          src={charmimarImage}
          alt="Charminar, Hyderabad"
        />

        {/* Hyderabad — established center */}
        <div className="ps-card ps-card--hyderabad">
          <div className="ps-card-header ps-card-header--hyderabad">
            <h3>
              IIA HYDERABAD <span>— Our Established Center</span>
            </h3>
          </div>
          <div className="ps-card-body">
            <p className="ps-card-sub">
              Wide range of programs across Mechanical, Manufacturing, Automation &amp; IT
            </p>
            <div className="ps-program-grid" role="list">
              {hyderabadPrograms.map((p) => (
                <ProgramCard key={p.label} {...p} />
              ))}
              {/* <div className="ps-more-card" role="listitem">
                <MoreHorizontal className="ps-more-icon" />
                <span className="ps-more-label">...and many more</span>
              </div> */}
            </div>
            <a href="/Secondactiveprograms" className="ps-link ps-link--blue" aria-label="View all programs in Hyderabad">
              View All Programs in Hyderabad
              <ArrowRight className="ps-link-icon" aria-hidden="true" />
            </a>
          </div>
        </div>

        {/* Jaipur — launching soon */}
        <div className="ps-card ps-card--jaipur">
          <div className="ps-card-header ps-card-header--jaipur">
            <h3>
              IIA JAIPUR <span>— Launching Soon</span>
            </h3>
          </div>
          <div className="ps-card-body">
            <p className="ps-card-sub">Focused programs to build industry-ready specialists</p>
            <div className="ps-jaipur-grid" role="list">
              {jaipurPrograms.map((p) => (
                <JaipurCard key={p.label} {...p} />
              ))}
            </div>
            <a href="#" className="ps-link ps-link--orange" aria-label="View programs in Jaipur">
              View Programs in Jaipur
              <ArrowRight className="ps-link-icon" aria-hidden="true" />
            </a>
          </div>
        </div>

        <SideImage
          side="right"
          src={hawaMahalImage}
          alt="Hawa Mahal, Jaipur"
        />
      </div>

      {/* Footer note */}
      {/* <div className="ps-footnote" role="note">
        <Info className="ps-footnote-icon" aria-hidden="true" />
        <span>More centers coming soon across India. Stay tuned!</span>
      </div> */}
    </section>
  );
}